export default "__VITE_ASSET__CDWMi6EV__"